import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { SectionCardIconeTituloLinkData } from '@fcp/lib-ui';
import { CardIconeTituloLinkContainerService } from './card-icone-titulo-link-container.service';

@Component({
  selector: 'fcp-card-icone-titulo-link-container',
  template: `
    <fcp-section-card-icone-titulo-link
      [sectionCardIconeTituloLink]="data | async"
      (wasClicked)="wasClicked.emit($event)"
      (wasClickedPage)="wasClickedPage.emit($event)"
    ></fcp-section-card-icone-titulo-link>
  `
})
export class CardIconeTituloLinkContainerComponent implements OnInit {
  @Input() public id: string;
  @Output() public wasClicked: EventEmitter<any> = new EventEmitter();
  @Output() public wasClickedPage: EventEmitter<any> = new EventEmitter();

  public data: Observable<SectionCardIconeTituloLinkData>;

  constructor(private cardIconeTituloLinkContainerService: CardIconeTituloLinkContainerService) {}

  ngOnInit() {
    this.data = this.cardIconeTituloLinkContainerService.getCardIconeTituloLink(this.id);
  }
}
